import { TextField, Typography } from '@eventbrite/marmalade';
import React from 'react';

export interface NameInformationProps {
  isDisabled: boolean;
  first_name: string;
  last_name: string;
  setFirstName: (name: string) => void;
  setLastName: (name: string) => void;
  validatedLastName?: string;
  validatedFirstName?: string;
}

const NameInformation: React.FC<NameInformationProps> = ({
  isDisabled,
  first_name,
  last_name,
  setFirstName,
  setLastName,
  validatedLastName,
  validatedFirstName,
}) => {
  const handleFirstNameChange = (
    value: string,
    name: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setFirstName(value);
  };
  const handleLastNameChange = (
    value: string,
    name: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setLastName(value);
  };
  return (
    <div>
      <TextField
        data-testid="first_name"
        id="first_name"
        label="First name"
        required
        value={first_name}
        type="text"
        hasError={!!validatedFirstName}
        helperText={validatedFirstName}
        onChange={handleFirstNameChange}
        crossOrigin={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        disabled={isDisabled}
      />
      <div style={{ margin: '24px' }} />
      <TextField
        data-testid="last_name"
        id="last_name"
        label="Last name"
        required
        type="text"
        hasError={!!validatedLastName}
        helperText={validatedLastName}
        value={last_name}
        onChange={handleLastNameChange}
        crossOrigin={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        disabled={isDisabled}
      />
      <Typography variant="body-sm">Last name needs to match the order</Typography>
    </div>
  );
};

export default NameInformation;
